import { InputData_Protobuf_Bucket } from '@policyfly/protobuf/pfschema'
import { computed } from 'vue'

import { useProtobufStore } from '@/stores/protobuf'

import type { CreateMapFn } from '@/stores/programData'
import type { Vehicle } from '@policyfly/protobuf'
import type { ComputedRef } from 'vue'

export function createMtcNtlCombinedVehiclesComputed (): ComputedRef<Vehicle[]> {
  const protobufStore = useProtobufStore()

  const deduplicateByVin = (vehicles: Vehicle[]): Vehicle[] =>
    vehicles.filter((vehicle, index, arr) =>
      index === arr.findIndex((v) => v?.vin === vehicle?.vin),
    )

  return computed(() => {
    const mtcVehicles = protobufStore.getValue({ path: 'coverages.(type=1004).transportation.vehicles' }, { defaultBucket: InputData_Protobuf_Bucket.BUCKET_PS })
    const ntlVehicles = protobufStore.getValue({ path: 'coverages.(type=73).transportation.vehicles' }, { defaultBucket: InputData_Protobuf_Bucket.BUCKET_PS })
    const mtcArray = Array.isArray(mtcVehicles) ? mtcVehicles : []
    const ntlArray = Array.isArray(ntlVehicles) ? ntlVehicles : []

    const uniqueMtc = deduplicateByVin(mtcArray)
    const uniqueNtl = deduplicateByVin(ntlArray)
    const combinedVehicles = [...uniqueMtc, ...uniqueNtl]

    return combinedVehicles.filter((vehicle) => {
      const removedWithId = vehicle?.removedWith?.id
      return removedWithId === null || removedWithId === 0 || removedWithId === undefined
    })
  })
}

export const createMap: CreateMapFn = () => {
  return {
    mtcNtlCombinedVehicles: createMtcNtlCombinedVehiclesComputed(),
  }
}
